import React from "react";
import AutocodeSchedulesIndex from "../features/autocodeSchedules";

export default function AutocodeSchedulesPage() {
  return (
    <AutocodeSchedulesIndex />
  );
}